import { render } from "./HistoricDashboard.vue?vue&type=template&id=c4c0de54&scoped=true"
import script from "./HistoricDashboard.vue?vue&type=script&lang=js"
export * from "./HistoricDashboard.vue?vue&type=script&lang=js"

import "./HistoricDashboard.vue?vue&type=style&index=0&id=c4c0de54&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c0de54"]])

export default __exports__